export default class EntityBase {
  public id?: string;
  public created?: string;
  public modified?: string;
}
